(function($, duo, undefined) {

  "use strict";

  const EATABLE_MENU_CLASS = 'js-eatable-menu';
  const EATABLE_BUTTON_CLASS = 'js-eatable-menu-toggle';
  const HIDDEN_MENU_CLASS = 'js-eatable-menu-hidden-list';

  /**
  * @class EatableMenu
  * eats the menu when there isn't enough space (makes a dropdown of the hidden menu items)
  */
  class EatableMenu {

    /**
    * Creates an instance of EatableMenu
    */
    constructor({menuSelector, menuList} = {}) {
      this.menuSelector = menuSelector;
      this.menuList = menuList;

      // setup:
      this._setup();
    } /* constructor */

    /**
    * Setup and attach event listeners
    */
    _setup() {

      // menu check:
      this._menuCheck();

      // setup event handlers:
      this._setEventHandlers();
    } /* _setup */

    _menuCheck() {
      let nav = this.menuSelector + ' nav';
      let navItem = this.menuSelector + ' nav .menu li';
      let navLastItem = this.menuSelector + ' nav .menu li:last';
      
      // horizontal room we have to work with (the container)
      let navPaddingLeft = parseFloat($(nav).css('padding-left'));
      let navPaddingRight = parseFloat($(nav).css('padding-right'));
      let navWidth = $(nav).outerWidth() - (navPaddingLeft + navPaddingRight);

      // calc the combined width of all links currently in the horizontal menu  
      let linksWidth = 0;

      $(navItem).each(function() {
        let margeLeft = parseFloat($(this).css('margin-left'));
        let margeRight = parseFloat($(this).css('margin-right'));

        linksWidth += $(this).outerWidth();
        linksWidth += margeLeft + margeRight;
      });

      // compare them to see if all the links fit in the container
      if( linksWidth > navWidth ) {

          // keep moving links from the menu to the hidden list
          while (linksWidth > navWidth) {
            let lastItem = $(navLastItem); // last link

            let lastItemMargeLeft = parseFloat(lastItem.css('margin-left'));
            let lastItemMargeRight = parseFloat(lastItem.css('margin-right'));
            let lastItemWidth = lastItem.outerWidth() + lastItemMargeLeft + lastItemMargeRight;
            $(lastItem).data('store', lastItemWidth); // store the width 

            $(this.menuList).prepend(lastItem); // pop the list item and push it to the hidden list

            linksWidth = linksWidth - lastItemWidth; // recalculate the linksWidth since we removed one
          }

          // Show eatable menu
          if ($(this.menuList + ' > li').length > 0) {
            $(`.${EATABLE_MENU_CLASS}`).attr('aria-hidden', 'false');
          }

      } else {

        // move links from the hidden list back into the menu
        while (linksWidth <= navWidth) {
          let firstOverflowItem = $(this.menuList + ' > li');
          let firstOverflowItemWidth = firstOverflowItem.data('store'); // get the stored width

          if (navWidth - linksWidth > firstOverflowItemWidth) {
              $(nav).find('.menu').append(firstOverflowItem); // pop the list item and push it back to the main nav
          }

          linksWidth = linksWidth + firstOverflowItemWidth; // recalculate the linksWidth since we added one

        }

        // Hide eatable menu
        if ($(this.menuList + ' > li').length == 0) {
          $(`.${EATABLE_MENU_CLASS}`).attr('aria-hidden', 'true');
        }

      }
    } /* _menuCheck */

    /**
    * Attach event listeners
    */
    _setEventHandlers() {
      const eatablemenu = this;

      // resize-event:
      let resizeTimer;
      let checkBusy = false;
      const $window = $(window);
      const lastWidth = $window.width();
      $(window).on('resize.eatablemenu', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          if(!checkBusy) {
            if($window.width() !== lastWidth) {
              checkBusy = true;
              // resizing has stopped, run check again:
              eatablemenu._menuCheck();
              checkBusy = false;
            }
          }
        }, 20);
      });

      // toggle hidden menu:
      $(document).once().on('click', `.${EATABLE_BUTTON_CLASS}`, function(event) {
        event.preventDefault();

        if ($(`.${HIDDEN_MENU_CLASS}`).attr('aria-hidden') == 'true') {
          $(`.${HIDDEN_MENU_CLASS}`).attr('aria-hidden', 'false');
        } else {
          $(`.${HIDDEN_MENU_CLASS}`).attr('aria-hidden', 'true');
        }
      });

      $(document).on('keydown.eatablemenu', function(event) {
        if(event.keyCode === 27) {
          if ($(`.${HIDDEN_MENU_CLASS}`).attr('aria-hidden') == 'false') {
            $(`.${HIDDEN_MENU_CLASS}`).attr('aria-hidden', 'true');
          }
        }
      });

    } /* _setEventHandlers */

  } /* EatableMenu */

  duo.EatableMenu = EatableMenu;

})(jQuery, window.duo = window.duo || {});
